import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  data: SelectItem[] | null = null;

  onChange = new EventEmitter();

  constructor() {}
}
